import React from 'react';
import { useMemo } from 'react';
import classnames from 'classnames';
import './index.scss';
import SvgIcon from '@/pages/home/components/SvgIcon';

const btnClassNameMap: any = {
  left: 'btn-left-icon',
  right: 'btn-right-icon',
};

const SlideBtn = (props: any) => {
  const { direction, className, style, onClick } = props;

  const btnClassName = useMemo(
    () => btnClassNameMap[direction] || '',
    [direction],
  );

  const handleBtnClick = (...args: any[]) => {
    onClick instanceof Function && onClick(...args);
  };

  return (
    <div
      className={classnames('segment-slider-btn', className)}
      onClick={handleBtnClick}
    >
      <span
        className={classnames('segment-slider-btn-icon', btnClassName)}
        style={{ ...style }}
      >
        <SvgIcon type="point-right" className="segment-slider-btn-svg" />
      </span>
    </div>
  );
};

export default SlideBtn;
